module.exports = __webpack_public_path__ + "img/amatic.cf006572.svg";